import "./styles.css";
import { useEffect, useMemo, useState } from "react";

const storeSources: Record<string, string[]> = {
  "Audi Pacific": [
    "All Sources",
    "AAA",
    "Autotrader.com",
    "Carfax.com",
    "Costco.com",
    "Cars.com",
    "Dealer Website",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
    "TrueCar",
  ],
  "Genesis Santa Monica": [
    "All Sources",
    "AAA",
    "Autotrader.com",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Oem",
    "TrueCar",
    "Dealer Website",
  ],
  "Honda Santa Monica": [
    "All Sources",
    "Auto Club SoCal",
    "AAA",
    "Autotrader.com",
    "Capital One",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
    "TrueCar",
    "Dealer Website",
  ],
  "Hyundai Santa Monica": [
    "All Sources",
    "Dealer Website",
    "AAA",
    "Autotrader.com",
    "Capital One",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
    "TrueCar",
  ],
  "Kia Santa Monica": [
    "All Sources",
    "Autotrader.com",
    "Capital One",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Dealer Website",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
    "TrueCar",
  ],
  "Lexus Santa Monica": [
    "All Sources",
    "Dealer Website",
    "AAA",
    "Autotrader.com",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Edmunds.com",
    "Oem",
  ],
  "Pacific Volkswagen": [
    "All Sources",
    "Dealer Website",
    "AAA",
    "Autotrader.com",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
  ],
  "Porsche South Bay": [
    "All Sources",
    "Dealer Website",
    "Oem",
    "Autotrader.com",
    "Cargurus.com",
    "Carfax.com",
    "Cars.com",
  ],
  "Subaru Pacific": [
    "All Sources",
    "Dealer Website",
    "AAA",
    "Autotrader.com",
    "Carfax.com",
    "Cars.com",
    "Costco.com",
    "Edmunds.com",
    "Oem",
    "TrueCar",
  ],
  "Subaru Santa Monica": [
    "All Sources",
    "Dealer Website",
    "Autotrader.com",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Edmunds.com",
    "Oem",
    "TrueCar",
  ],
  "Toyota of Hollywood": [
    "All Sources",
    "Dealer Website",
    "AAA",
    "Autotrader.com",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
    "TrueCar",
  ],
  "Toyota Santa Monica": [
    "All Sources",
    "Dealer Website",
    "Autotrader.com",
    "Capital One",
    "Carfax.com",
    "Cargurus.com",
    "Cars.com",
    "Costco.com",
    "Edmunds.com",
    "Oem",
    "OEM 3PL",
    "TrueCar",
  ],
};

const stores = ["All Stores", ...Object.keys(storeSources)];

type InventoryType = "All" | "New" | "Used";
type SocialPlatform = "Instagram" | "Facebook" | "TikTok" | "YouTube";

type SalesRow = {
  store: string;
  source: string;
  inventoryType: "New" | "Used";
  leads: number;
  appointments: number;
  sold: number;
  date: string;
};

type CallsRow = {
  store: string;
  source: string;
  inventoryType: "New" | "Used";
  calls: number;
  answered: number;
  missed: number;
  date: string;
};

type AnalyticsRow = {
  store: string;
  campaign: string;
  spend: number;
  clicks: number;
  sessions: number;
  conversions: number;
  forms: number;
  calls: number;
  chat: number;
  views: number;
  costPerClick: number | null;
  date: string;
};

type EmailRow = {
  store: string;
  campaign: string;
  sent: number;
  opens: number;
  clicks: number;
  unsubscribes: number;
  date: string;
};

type SocialRow = {
  store: string;
  platform: SocialPlatform;
  campaign: string;
  impressions: number;
  reach: number;
  clicks: number;
  engagement: number;
  followers: number;
  date: string;
};

const salesData: SalesRow[] = [
  {
    store: "Kia Santa Monica",
    source: "Cars.com",
    inventoryType: "New",
    leads: 42,
    appointments: 11,
    sold: 4,
    date: "2026-03-01",
  },
  {
    store: "Genesis Santa Monica",
    source: "Dealer Website",
    inventoryType: "Used",
    leads: 31,
    appointments: 8,
    sold: 3,
    date: "2026-03-03",
  },
  {
    store: "Honda Santa Monica",
    source: "Capital One",
    inventoryType: "New",
    leads: 25,
    appointments: 7,
    sold: 2,
    date: "2026-03-05",
  },
  {
    store: "Hyundai Santa Monica",
    source: "Autotrader.com",
    inventoryType: "Used",
    leads: 38,
    appointments: 10,
    sold: 5,
    date: "2026-03-06",
  },
  {
    store: "Audi Pacific",
    source: "TrueCar",
    inventoryType: "New",
    leads: 19,
    appointments: 5,
    sold: 2,
    date: "2026-03-07",
  },
  {
    store: "Toyota Santa Monica",
    source: "Cars.com",
    inventoryType: "Used",
    leads: 29,
    appointments: 8,
    sold: 3,
    date: "2026-03-14",
  },
];

const callsData: CallsRow[] = [
  {
    store: "Kia Santa Monica",
    source: "Cars.com",
    inventoryType: "New",
    calls: 58,
    answered: 50,
    missed: 8,
    date: "2026-03-01",
  },
  {
    store: "Genesis Santa Monica",
    source: "Dealer Website",
    inventoryType: "Used",
    calls: 41,
    answered: 35,
    missed: 6,
    date: "2026-03-03",
  },
  {
    store: "Honda Santa Monica",
    source: "Capital One",
    inventoryType: "New",
    calls: 32,
    answered: 29,
    missed: 3,
    date: "2026-03-05",
  },
];

const analyticsData: AnalyticsRow[] = [
  {
    store: "Kia Santa Monica",
    campaign: "March New Inventory",
    spend: 0,
    clicks: 1280,
    sessions: 5681,
    conversions: 48,
    forms: 9,
    calls: 25,
    chat: 0,
    views: 10233,
    costPerClick: null,
    date: "2026-03-01",
  },
  {
    store: "Honda Santa Monica",
    campaign: "Used Car Push",
    spend: 2700,
    clicks: 920,
    sessions: 760,
    conversions: 35,
    forms: 7,
    calls: 12,
    chat: 3,
    views: 6840,
    costPerClick: 2.93,
    date: "2026-03-04",
  },
  {
    store: "Toyota Santa Monica",
    campaign: "SUV Weekend",
    spend: 3900,
    clicks: 1350,
    sessions: 1080,
    conversions: 52,
    forms: 14,
    calls: 18,
    chat: 5,
    views: 12112,
    costPerClick: 2.89,
    date: "2026-03-10",
  },
];

const emailData: EmailRow[] = [
  {
    store: "Kia Santa Monica",
    campaign: "Spring Offers",
    sent: 12000,
    opens: 3840,
    clicks: 420,
    unsubscribes: 21,
    date: "2026-03-02",
  },
  {
    store: "Genesis Santa Monica",
    campaign: "Luxury Upgrade Event",
    sent: 5400,
    opens: 2100,
    clicks: 265,
    unsubscribes: 9,
    date: "2026-03-05",
  },
  {
    store: "Toyota of Hollywood",
    campaign: "Weekend Savings",
    sent: 9800,
    opens: 3010,
    clicks: 355,
    unsubscribes: 18,
    date: "2026-03-11",
  },
];

const socialData: SocialRow[] = [
  {
    store: "Kia Santa Monica",
    platform: "Instagram",
    campaign: "Spring Reels",
    impressions: 182000,
    reach: 92100,
    clicks: 2140,
    engagement: 6420,
    followers: 18340,
    date: "2026-03-02",
  },
  {
    store: "Kia Santa Monica",
    platform: "Facebook",
    campaign: "Weekend Offers",
    impressions: 126000,
    reach: 80300,
    clicks: 1680,
    engagement: 3820,
    followers: 22140,
    date: "2026-03-04",
  },
  {
    store: "Honda Santa Monica",
    platform: "TikTok",
    campaign: "Used Inventory Clips",
    impressions: 242000,
    reach: 138000,
    clicks: 2980,
    engagement: 9150,
    followers: 28420,
    date: "2026-03-06",
  },
  {
    store: "Toyota Santa Monica",
    platform: "YouTube",
    campaign: "SUV Video Series",
    impressions: 98000,
    reach: 52000,
    clicks: 1260,
    engagement: 2490,
    followers: 11780,
    date: "2026-03-08",
  },
  {
    store: "Genesis Santa Monica",
    platform: "Instagram",
    campaign: "Luxury Event Promo",
    impressions: 76000,
    reach: 40100,
    clicks: 940,
    engagement: 3110,
    followers: 10220,
    date: "2026-03-12",
  },
];

function DynamicTrendTable({
  title,
  rows,
}: {
  title: string;
  rows: Record<string, any>[];
}) {
  if (!rows || rows.length === 0) {
    return (
      <div className="table-card">
        <div className="table-title">
          <div>
            <h2>{title}</h2>
            <p>0 rows shown</p>
          </div>
        </div>
        <div className="empty-cell">No results found.</div>
      </div>
    );
  }

  const headers = Object.keys(rows[0]);

  return (
    <div className="table-card">
      <div className="table-title">
        <div>
          <h2>{title}</h2>
          <p>{rows.length} rows shown</p>
        </div>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {headers.map((header) => (
                  <td key={header}>
                    {typeof row[header] === "number"
                      ? row[header].toLocaleString()
                      : row[header] ?? "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function MetricValue({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) {
  return (
    <div className="mini-metric-card">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState("sales");
  const [reportCategory, setReportCategory] = useState("trend");
  const [trendReportTab, setTrendReportTab] = useState("INTERNET");
  const [reportPeriod, setReportPeriod] = useState("Weekly");
  const [trendData, setTrendData] = useState<Record<
    string,
    Record<string, any>[]
  > | null>(null);

  const [store, setStore] = useState("All Stores");
  const [source, setSource] = useState("All Sources");
  const [inventoryType, setInventoryType] = useState<InventoryType>("All");
  const [dateFrom, setDateFrom] = useState("2026-03-01");
  const [dateTo, setDateTo] = useState("2026-03-31");
  const [socialPlatform, setSocialPlatform] =
    useState<SocialPlatform>("Instagram");

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("lacarguy-auth") === "true";
  });
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    fetch("/trend-report-data.json")
      .then((res) => res.json())
      .then((data) => setTrendData(data))
      .catch((err) => console.error("Failed to load trend report data", err));
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();

    const allowedEmail = "francisco@lacarguy.com";
    const allowedPassword = "Hindry2024";

    if (
      loginEmail.trim().toLowerCase() === allowedEmail &&
      loginPassword === allowedPassword
    ) {
      localStorage.setItem("lacarguy-auth", "true");
      setIsAuthenticated(true);
      setLoginError("");
      return;
    }

    setLoginError("Invalid email or password.");
  };

  const handleLogout = () => {
    localStorage.removeItem("lacarguy-auth");
    setIsAuthenticated(false);
    setLoginEmail("");
    setLoginPassword("");
    setLoginError("");
  };

  const sourceOptions = useMemo(() => {
    if (store === "All Stores") return ["All Sources"];
    return storeSources[store] || ["All Sources"];
  }, [store]);

  const filteredSales = useMemo(() => {
    return salesData.filter((row) => {
      const storeMatch = store === "All Stores" || row.store === store;
      const sourceMatch = source === "All Sources" || row.source === source;
      const typeMatch =
        inventoryType === "All" || row.inventoryType === inventoryType;
      const fromMatch = !dateFrom || row.date >= dateFrom;
      const toMatch = !dateTo || row.date <= dateTo;
      return storeMatch && sourceMatch && typeMatch && fromMatch && toMatch;
    });
  }, [store, source, inventoryType, dateFrom, dateTo]);

  const filteredCalls = useMemo(() => {
    return callsData.filter((row) => {
      const storeMatch = store === "All Stores" || row.store === store;
      const sourceMatch = source === "All Sources" || row.source === source;
      const typeMatch =
        inventoryType === "All" || row.inventoryType === inventoryType;
      const fromMatch = !dateFrom || row.date >= dateFrom;
      const toMatch = !dateTo || row.date <= dateTo;
      return storeMatch && sourceMatch && typeMatch && fromMatch && toMatch;
    });
  }, [store, source, inventoryType, dateFrom, dateTo]);

  const filteredAnalytics = useMemo(() => {
    return analyticsData.filter((row) => {
      const storeMatch = store === "All Stores" || row.store === store;
      const fromMatch = !dateFrom || row.date >= dateFrom;
      const toMatch = !dateTo || row.date <= dateTo;
      return storeMatch && fromMatch && toMatch;
    });
  }, [store, dateFrom, dateTo]);

  const filteredEmails = useMemo(() => {
    return emailData.filter((row) => {
      const storeMatch = store === "All Stores" || row.store === store;
      const fromMatch = !dateFrom || row.date >= dateFrom;
      const toMatch = !dateTo || row.date <= dateTo;
      return storeMatch && fromMatch && toMatch;
    });
  }, [store, dateFrom, dateTo]);

  const filteredSocial = useMemo(() => {
    return socialData.filter((row) => {
      const storeMatch = store === "All Stores" || row.store === store;
      const platformMatch = row.platform === socialPlatform;
      const fromMatch = !dateFrom || row.date >= dateFrom;
      const toMatch = !dateTo || row.date <= dateTo;
      return storeMatch && platformMatch && fromMatch && toMatch;
    });
  }, [store, socialPlatform, dateFrom, dateTo]);

  const salesTotals = useMemo(() => {
    return filteredSales.reduce(
      (acc, row) => {
        acc.leads += row.leads;
        acc.appointments += row.appointments;
        acc.sold += row.sold;
        return acc;
      },
      { leads: 0, appointments: 0, sold: 0 }
    );
  }, [filteredSales]);

  const callsTotals = useMemo(() => {
    return filteredCalls.reduce(
      (acc, row) => {
        acc.calls += row.calls;
        acc.answered += row.answered;
        acc.missed += row.missed;
        return acc;
      },
      { calls: 0, answered: 0, missed: 0 }
    );
  }, [filteredCalls]);

  const analyticsTotals = useMemo(() => {
    return filteredAnalytics.reduce(
      (acc, row) => {
        acc.spend += row.spend;
        acc.clicks += row.clicks;
        acc.sessions += row.sessions;
        acc.conversions += row.conversions;
        acc.forms += row.forms;
        acc.calls += row.calls;
        acc.chat += row.chat;
        acc.views += row.views;
        acc.costPerClickSum += row.costPerClick ?? 0;
        acc.costPerClickCount += row.costPerClick != null ? 1 : 0;
        return acc;
      },
      {
        spend: 0,
        clicks: 0,
        sessions: 0,
        conversions: 0,
        forms: 0,
        calls: 0,
        chat: 0,
        views: 0,
        costPerClickSum: 0,
        costPerClickCount: 0,
      }
    );
  }, [filteredAnalytics]);

  const emailTotals = useMemo(() => {
    return filteredEmails.reduce(
      (acc, row) => {
        acc.sent += row.sent;
        acc.opens += row.opens;
        acc.clicks += row.clicks;
        acc.unsubscribes += row.unsubscribes;
        return acc;
      },
      { sent: 0, opens: 0, clicks: 0, unsubscribes: 0 }
    );
  }, [filteredEmails]);

  const socialTotals = useMemo(() => {
    return filteredSocial.reduce(
      (acc, row) => {
        acc.impressions += row.impressions;
        acc.reach += row.reach;
        acc.clicks += row.clicks;
        acc.engagement += row.engagement;
        acc.followers += row.followers;
        return acc;
      },
      {
        impressions: 0,
        reach: 0,
        clicks: 0,
        engagement: 0,
        followers: 0,
      }
    );
  }, [filteredSocial]);

  const reportRows = useMemo(() => {
    if (!trendData) return [];

    if (trendReportTab === "TRAFFIC") return trendData["TRAFFIC"] || [];

    if (trendReportTab === "INTERNET") {
      return inventoryType === "Used"
        ? trendData["INTERNET USED"] || []
        : trendData["INTERNET NEW"] || [];
    }

    if (trendReportTab === "CALLS") {
      return inventoryType === "Used"
        ? trendData["CALLS USED"] || []
        : trendData["CALLS NEW"] || [];
    }

    return [];
  }, [trendData, trendReportTab, inventoryType]);

  const showSourceAndType =
    page === "sales" || page === "calls" || page === "reports";

  const avgCostPerClick =
    analyticsTotals.costPerClickCount > 0
      ? analyticsTotals.costPerClickSum / analyticsTotals.costPerClickCount
      : null;

  if (!isAuthenticated) {
    return (
      <div className="login-shell">
        <div className="login-panel">
          <div className="login-hero">
            <div className="login-logo-card">
              <img src="/logo.png" alt="LaCarGuy" className="login-logo" />
            </div>

            <div className="login-copy">
              <span className="eyebrow">Private dashboard access</span>
              <h1>LaCarGuy Intelligence Suite</h1>
              <p>
                Secure access to marketing performance, calls, analytics, social
                media, email trends, and executive reporting.
              </p>
            </div>
          </div>

          <div className="login-card">
            <div className="login-card-head">
              <h2>Sign in</h2>
              <p>Use your internal credentials to continue.</p>
            </div>

            <form onSubmit={handleLogin} className="login-form">
              <div className="login-field">
                <label>Email</label>
                <input
                  type="email"
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                  placeholder="francisco@lacarguy.com"
                />
              </div>

              <div className="login-field">
                <label>Password</label>
                <input
                  type="password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  placeholder="Enter password"
                />
              </div>

              {loginError && <div className="login-error">{loginError}</div>}

              <button className="primary-btn login-btn" type="submit">
                Enter Dashboard
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <div className="dashboard-backdrop" />

      <div className="container">
        <div className="topbar">
          <div className="brand-wrap">
            <div className="brand-logo-card">
              <img src="/logo.png" alt="LaCarGuy" className="brand-logo" />
            </div>

            <div className="brand-copy">
              <span className="eyebrow">Executive reporting</span>
              <h1>Marketing Performance Dashboard</h1>
              <p>
                Premium visibility across leads, calls, analytics, social,
                email, and trend reporting.
              </p>
            </div>
          </div>

          <div className="topbar-actions">
            <button className="ghost-btn" type="button">
              Export
            </button>
            <button
              className="primary-btn"
              type="button"
              onClick={handleLogout}
            >
              Log Out
            </button>
          </div>
        </div>

        <div className="tabs-row">
          <button
            className={page === "sales" ? "tab-btn active-tab" : "tab-btn"}
            onClick={() => setPage("sales")}
            type="button"
          >
            Leads
          </button>
          <button
            className={page === "calls" ? "tab-btn active-tab" : "tab-btn"}
            onClick={() => setPage("calls")}
            type="button"
          >
            Calls
          </button>
          <button
            className={page === "analytics" ? "tab-btn active-tab" : "tab-btn"}
            onClick={() => setPage("analytics")}
            type="button"
          >
            Analytics
          </button>
          <button
            className={page === "emails" ? "tab-btn active-tab" : "tab-btn"}
            onClick={() => setPage("emails")}
            type="button"
          >
            Emails
          </button>
          <button
            className={page === "social" ? "tab-btn active-tab" : "tab-btn"}
            onClick={() => setPage("social")}
            type="button"
          >
            Social
          </button>
          <button
            className={page === "reports" ? "tab-btn active-tab" : "tab-btn"}
            onClick={() => setPage("reports")}
            type="button"
          >
            Reports
          </button>
        </div>

        <div className="filters-grid">
          <div className="filter-card">
            <label>Store</label>
            <select
              value={store}
              onChange={(e) => {
                const nextStore = e.target.value;
                setStore(nextStore);
                setSource("All Sources");
              }}
            >
              {stores.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          {showSourceAndType && (
            <>
              {page !== "reports" && (
                <div className="filter-card">
                  <label>Source</label>
                  <select
                    value={source}
                    onChange={(e) => setSource(e.target.value)}
                    disabled={store === "All Stores"}
                  >
                    {sourceOptions.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="filter-card">
                <label>Inventory</label>
                <div className="segmented">
                  <button
                    type="button"
                    className={
                      inventoryType === "All"
                        ? "segment-btn active-segment"
                        : "segment-btn"
                    }
                    onClick={() => setInventoryType("All")}
                  >
                    All
                  </button>
                  <button
                    type="button"
                    className={
                      inventoryType === "New"
                        ? "segment-btn active-segment"
                        : "segment-btn"
                    }
                    onClick={() => setInventoryType("New")}
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className={
                      inventoryType === "Used"
                        ? "segment-btn active-segment"
                        : "segment-btn"
                    }
                    onClick={() => setInventoryType("Used")}
                  >
                    Used
                  </button>
                </div>
              </div>
            </>
          )}

          {page === "social" && (
            <div className="filter-card report-period-card">
              <label>Platform</label>
              <div className="segmented">
                {(
                  [
                    "Instagram",
                    "Facebook",
                    "TikTok",
                    "YouTube",
                  ] as SocialPlatform[]
                ).map((platform) => (
                  <button
                    key={platform}
                    type="button"
                    className={
                      socialPlatform === platform
                        ? "segment-btn active-segment"
                        : "segment-btn"
                    }
                    onClick={() => setSocialPlatform(platform)}
                  >
                    {platform}
                  </button>
                ))}
              </div>
            </div>
          )}

          {page !== "reports" && (
            <>
              <div className="filter-card">
                <label>Date From</label>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </div>

              <div className="filter-card">
                <label>Date To</label>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </div>
            </>
          )}

          {page === "reports" && (
            <div className="filter-card report-period-card">
              <label>Report Period</label>
              <div className="segmented">
                <button
                  type="button"
                  className={
                    reportPeriod === "Weekly"
                      ? "segment-btn active-segment"
                      : "segment-btn"
                  }
                  onClick={() => setReportPeriod("Weekly")}
                >
                  Weekly
                </button>
                <button
                  type="button"
                  className={
                    reportPeriod === "Bi-Weekly"
                      ? "segment-btn active-segment"
                      : "segment-btn"
                  }
                  onClick={() => setReportPeriod("Bi-Weekly")}
                >
                  Bi-Weekly
                </button>
                <button
                  type="button"
                  className={
                    reportPeriod === "Monthly"
                      ? "segment-btn active-segment"
                      : "segment-btn"
                  }
                  onClick={() => setReportPeriod("Monthly")}
                >
                  Monthly
                </button>
              </div>
            </div>
          )}
        </div>

        {page === "sales" && (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <span>Total Leads</span>
                <strong>{salesTotals.leads}</strong>
              </div>
              <div className="stat-card">
                <span>Appointments</span>
                <strong>{salesTotals.appointments}</strong>
              </div>
              <div className="stat-card">
                <span>Sold</span>
                <strong>{salesTotals.sold}</strong>
              </div>
            </div>

            <div className="table-card">
              <div className="table-title">
                <div>
                  <h2>Lead Overview</h2>
                  <p>{filteredSales.length} rows shown</p>
                </div>
              </div>

              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Store</th>
                      <th>Source</th>
                      <th>Type</th>
                      <th>Leads</th>
                      <th>Appointments</th>
                      <th>Sold</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSales.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.store}</td>
                        <td>
                          <span className="pill">{row.source}</span>
                        </td>
                        <td>{row.inventoryType}</td>
                        <td>{row.leads}</td>
                        <td>{row.appointments}</td>
                        <td>{row.sold}</td>
                      </tr>
                    ))}
                    {filteredSales.length === 0 && (
                      <tr>
                        <td colSpan={7} className="empty-cell">
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {page === "calls" && (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <span>Total Calls</span>
                <strong>{callsTotals.calls}</strong>
              </div>
              <div className="stat-card">
                <span>Answered</span>
                <strong>{callsTotals.answered}</strong>
              </div>
              <div className="stat-card">
                <span>Missed</span>
                <strong>{callsTotals.missed}</strong>
              </div>
            </div>

            <div className="table-card">
              <div className="table-title">
                <div>
                  <h2>Calls Overview</h2>
                  <p>{filteredCalls.length} rows shown</p>
                </div>
              </div>

              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Store</th>
                      <th>Source</th>
                      <th>Type</th>
                      <th>Calls</th>
                      <th>Answered</th>
                      <th>Missed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCalls.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.store}</td>
                        <td>
                          <span className="pill">{row.source}</span>
                        </td>
                        <td>{row.inventoryType}</td>
                        <td>{row.calls}</td>
                        <td>{row.answered}</td>
                        <td>{row.missed}</td>
                      </tr>
                    ))}
                    {filteredCalls.length === 0 && (
                      <tr>
                        <td colSpan={7} className="empty-cell">
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {page === "analytics" && (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <span>Spend</span>
                <strong>${analyticsTotals.spend.toLocaleString()}</strong>
              </div>
              <div className="stat-card">
                <span>Sessions</span>
                <strong>{analyticsTotals.sessions.toLocaleString()}</strong>
              </div>
              <div className="stat-card">
                <span>Forms</span>
                <strong>{analyticsTotals.forms.toLocaleString()}</strong>
              </div>
            </div>

            <div className="mini-metrics-grid">
              <MetricValue
                label="Spend"
                value={`$${analyticsTotals.spend.toLocaleString()}.00`}
              />
              <MetricValue
                label="Sessions"
                value={
                  analyticsTotals.sessions >= 1000
                    ? `${(analyticsTotals.sessions / 1000).toFixed(3)}K`
                    : analyticsTotals.sessions.toLocaleString()
                }
              />
              <MetricValue label="Forms" value={analyticsTotals.forms} />
              <MetricValue label="Calls" value={analyticsTotals.calls} />
              <MetricValue label="Chat" value={analyticsTotals.chat} />
              <MetricValue
                label="Views"
                value={analyticsTotals.views.toLocaleString()}
              />
              <MetricValue
                label="Ads Cost Per Click"
                value={
                  avgCostPerClick == null
                    ? "No data"
                    : `$${avgCostPerClick.toFixed(2)}`
                }
              />
            </div>

            <div className="table-card">
              <div className="table-title">
                <div>
                  <h2>Analytics Overview</h2>
                  <p>{filteredAnalytics.length} rows shown</p>
                </div>
              </div>

              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Store</th>
                      <th>Campaign</th>
                      <th>Spend</th>
                      <th>Clicks</th>
                      <th>Sessions</th>
                      <th>Conversions</th>
                      <th>Forms</th>
                      <th>Calls</th>
                      <th>Chat</th>
                      <th>Views</th>
                      <th>CPC</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAnalytics.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.store}</td>
                        <td>
                          <span className="pill">{row.campaign}</span>
                        </td>
                        <td>${row.spend.toLocaleString()}</td>
                        <td>{row.clicks.toLocaleString()}</td>
                        <td>{row.sessions.toLocaleString()}</td>
                        <td>{row.conversions}</td>
                        <td>{row.forms}</td>
                        <td>{row.calls}</td>
                        <td>{row.chat}</td>
                        <td>{row.views.toLocaleString()}</td>
                        <td>
                          {row.costPerClick == null
                            ? "No data"
                            : `$${row.costPerClick.toFixed(2)}`}
                        </td>
                      </tr>
                    ))}
                    {filteredAnalytics.length === 0 && (
                      <tr>
                        <td colSpan={12} className="empty-cell">
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {page === "emails" && (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <span>Sent</span>
                <strong>{emailTotals.sent.toLocaleString()}</strong>
              </div>
              <div className="stat-card">
                <span>Opens</span>
                <strong>{emailTotals.opens.toLocaleString()}</strong>
              </div>
              <div className="stat-card">
                <span>Clicks</span>
                <strong>{emailTotals.clicks.toLocaleString()}</strong>
              </div>
            </div>

            <div className="table-card">
              <div className="table-title">
                <div>
                  <h2>Email Overview</h2>
                  <p>{filteredEmails.length} rows shown</p>
                </div>
              </div>

              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Store</th>
                      <th>Campaign</th>
                      <th>Sent</th>
                      <th>Opens</th>
                      <th>Clicks</th>
                      <th>Unsubscribes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredEmails.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.store}</td>
                        <td>
                          <span className="pill">{row.campaign}</span>
                        </td>
                        <td>{row.sent.toLocaleString()}</td>
                        <td>{row.opens.toLocaleString()}</td>
                        <td>{row.clicks.toLocaleString()}</td>
                        <td>{row.unsubscribes}</td>
                      </tr>
                    ))}
                    {filteredEmails.length === 0 && (
                      <tr>
                        <td colSpan={7} className="empty-cell">
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {page === "social" && (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <span>Impressions</span>
                <strong>{socialTotals.impressions.toLocaleString()}</strong>
              </div>
              <div className="stat-card">
                <span>Engagement</span>
                <strong>{socialTotals.engagement.toLocaleString()}</strong>
              </div>
              <div className="stat-card">
                <span>Followers</span>
                <strong>{socialTotals.followers.toLocaleString()}</strong>
              </div>
            </div>

            <div className="table-card">
              <div className="table-title">
                <div>
                  <h2>{socialPlatform} Overview</h2>
                  <p>{filteredSocial.length} rows shown</p>
                </div>
              </div>

              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Store</th>
                      <th>Platform</th>
                      <th>Campaign</th>
                      <th>Impressions</th>
                      <th>Reach</th>
                      <th>Clicks</th>
                      <th>Engagement</th>
                      <th>Followers</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSocial.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.store}</td>
                        <td>
                          <span className="pill">{row.platform}</span>
                        </td>
                        <td>{row.campaign}</td>
                        <td>{row.impressions.toLocaleString()}</td>
                        <td>{row.reach.toLocaleString()}</td>
                        <td>{row.clicks.toLocaleString()}</td>
                        <td>{row.engagement.toLocaleString()}</td>
                        <td>{row.followers.toLocaleString()}</td>
                      </tr>
                    ))}
                    {filteredSocial.length === 0 && (
                      <tr>
                        <td colSpan={9} className="empty-cell">
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {page === "reports" && (
          <>
            <div className="tabs-row inner-tabs">
              <button
                className={
                  reportCategory === "trend" ? "tab-btn active-tab" : "tab-btn"
                }
                onClick={() => setReportCategory("trend")}
                type="button"
              >
                Trend Reports
              </button>
            </div>

            {reportCategory === "trend" && (
              <>
                <div className="tabs-row inner-tabs">
                  <button
                    className={
                      trendReportTab === "INTERNET"
                        ? "tab-btn active-tab"
                        : "tab-btn"
                    }
                    onClick={() => setTrendReportTab("INTERNET")}
                    type="button"
                  >
                    Internet
                  </button>

                  <button
                    className={
                      trendReportTab === "CALLS"
                        ? "tab-btn active-tab"
                        : "tab-btn"
                    }
                    onClick={() => setTrendReportTab("CALLS")}
                    type="button"
                  >
                    Calls
                  </button>

                  <button
                    className={
                      trendReportTab === "TRAFFIC"
                        ? "tab-btn active-tab"
                        : "tab-btn"
                    }
                    onClick={() => setTrendReportTab("TRAFFIC")}
                    type="button"
                  >
                    Traffic
                  </button>
                </div>

                {!trendData ? (
                  <div className="table-card">
                    <div className="table-title">
                      <div>
                        <h2>Loading trend reports...</h2>
                        <p>
                          Make sure `trend-report-data.json` is inside `public`.
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <DynamicTrendTable
                    title={`${reportPeriod} · ${trendReportTab}${
                      trendReportTab !== "TRAFFIC"
                        ? ` · ${
                            inventoryType === "All" ? "New" : inventoryType
                          }`
                        : ""
                    }`}
                    rows={reportRows}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
